const Fonts = {
  h1: {
    fontFamily: "Sequel_100 Wide W05_45",
    fontSize: "64px",
    lineHeight: "76px",
  },
  h2: {
    fontFamily: "Sequel_100 Wide W05_55",
    fontSize: "56px",
    lineHeight: "64px",
  },
  h3: {
    fontFamily: "Sequel_100 Wide W05_65",
    fontSize: "36px",
    lineHeight: "44px",
  },
  h4f26: {
    fontFamily: "Sequel_100 Wide W05_65",
    fontSize: "26px",
    lineHeight: "36px",
  },
  h4: {
    fontFamily: "Sequel_100 Wide W05_65",
    fontSize: "22px",
    lineHeight: "36px",
  },
  h5: {
    fontFamily: "Sequel_100 Wide W05_55",
    fontSize: "19px",
    lineHeight: "24px",
  },
  h6: {
    fontFamily: "Sequel_100 Wide W05_55",
    fontSize: "16px",
    lineHeight: "24px",
  },
  h7: {
    fontFamily: "inter-700",
    fontSize: "16px",
    lineHeight: "16px",
  },
  h8: {
    fontFamily: "inter-600",
    fontSize: "15px",
    lineHeight: "20px",
  },
  h9: {
    fontFamily: "inter-600",
    fontSize: "14px",
    lineHeight: "16px",
  },

  p1: {
    fontFamily: "inter-400",
    fontSize: "16px",
    lineHeight: "24px",
  },
  p2: {
    fontFamily: "inter-400",
    fontSize: "14px",
    lineHeight: "20px",
  },
  //   This will be itallic
  p3: {
    fontFamily: "inter-400",
    fontSize: "14px",
    lineHeight: "20px",
  },
  p4: {
    fontFamily: "inter-400",
    fontSize: "12px",
    lineHeight: "16px",
  },
  b1: {
    fontFamily: "inter-600",
    fontSize: "16px",
    lineHeight: "32px",
  },
  b1Mobile: {
    fontFamily: "inter-400",
    fontSize: "16px",
    lineHeight: "24px",
  },
  b2: {
    fontFamily: "inter-500",
    fontSize: "14px",
    lineHeight: "16px",
  },
  // For Mobile
  b3: {
    fontFamily: "inter-600",
    fontSize: "16px",
    lineHeight: "24px",
  },
  b4: {
    fontFamily: "inter-600",
    fontSize: "14px",
    lineHeight: "16px",
  },
  input1: {
    fontFamily: "inter-500",
    fontSize: "16px",
    lineHeight: "24px",
  },
  input2: {
    fontFamily: "inter-400",
    fontSize: "14px",
    lineHeight: "20px",
  },
  input3: {
    fontFamily: "inter-600",
    fontSize: "12px",
    lineHeight: "16px",
  },
  controls: {
    fontFamily: "inter-400",
    fontSize: "14px",
    lineHeight: "20px",
  },
  otherMedium: {
    fontFamily: "inter-500",
    fontSize: "12px",
    lineHeight: "16px",
  },
  otherSemiBold: {
    fontFamily: "inter-600",
    fontSize: "12px",
    lineHeight: "20px",
  },
};
export default Fonts;
